module.exports = __webpack_public_path__ + "static/media/Sejuani.334bbb28.png";